import { render, staticRenderFns } from "./nav-list.vue?vue&type=template&id=f20c277e&"
import script from "./nav-list.vue?vue&type=script&lang=js&"
export * from "./nav-list.vue?vue&type=script&lang=js&"
import style0 from "./nav-list.vue?vue&type=style&index=0&id=f20c277e&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports